import React from "react";
import _ from "lodash";
import { FieldWrapper } from ".";
import { _getTranslation } from "../utils/helper";

const InputText = ({ type, placeholder, label, error, ...props }) => {
  const fieldHasError = _.isString(error) && error;
  const fieldPlaceholder = placeholder || _getTranslation("please_fill_in_here");
  const inputClasses = `w-full ${props.class ?? ""} ${
    fieldHasError ? "field-error" : ""
  }`;

  return (
    <FieldWrapper
      label={label}
      error={fieldHasError}
      twoColumnLayout={props?.twoColumnLayout}
    >
      {type === "textarea" ? (
        <textarea
          className={inputClasses}
          {...props}
          placeholder={fieldPlaceholder}
          rows={`${props.rows ?? 5}`}
        ></textarea>
      ) : (
        <input
          className={inputClasses}
          type={type || "text"}
          {...props}
          placeholder={fieldPlaceholder}
        />
      )}
    </FieldWrapper>
  );
};

export default InputText;
